import { PendingState } from '@wetransfer/transfer/store/types';

const pendingState: PendingState = {};

export default pendingState;
